import React from 'react';
import { cn } from '../lib/utils';

const VARIANTS = {
  success: 'bg-green-light text-green',
  muted:   'bg-gray-100 text-gray-500',
  accent:  'bg-forest text-mustard',
};

const Badge = ({ variant = 'muted', className, children }) => (
  <span
    className={cn(
      'text-[0.68rem] font-extrabold tracking-[0.06em] uppercase px-2 py-0.5 rounded inline-block',
      VARIANTS[variant],
      className,
    )}
  >
    {children}
  </span>
);

export default Badge;
